import React, { useEffect } from "react";
import AppNavbar from "../components/home/Navbar";
import Hero from "../components/home/Hero";
import HowItWorks from "../components/home/HowItWorks";
import Service from "../components/home/Service";
import About from "../components/home/About";
import Trust from "../components/home/Trust";
import FAQ from "../components/home/FAQ";
import Footer from "../components/footer/Footer";
import Seo from "../components/seo/Seo";
import { useDispatch } from "react-redux";
import { clearCart } from "../redux/actions/CartActions";
import { clearServiceList } from "../redux/actions/ServiceListActions";
import { clearRequest } from "../redux/actions/RequestActions";
import { PAGES } from "../content/pages";

function Home() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearCart());
    dispatch(clearServiceList());
    dispatch(clearRequest());
  }, [dispatch]);

  return (
    <div>
      <Seo {...PAGES.home} />
      <AppNavbar />
      <Hero />
      <HowItWorks />
      <Service />
      <Trust />
      <About />
      <FAQ />
      <Footer />
    </div>
  );
}

export default Home;
